/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsClockExclamation: {
  name: 'clock-exclamation';
  data: string;
} = {
  name: 'clock-exclamation',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 0 1 12.444-6.653 1 1 0 0 0 1.112-1.662A9.958 9.958 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c4.76 0 8.742-3.325 9.752-7.779a1 1 0 1 0-1.95-.442A8 8 0 0 1 4 12Zm9-4a1 1 0 1 0-2 0v3a2 2 0 0 0 2 2h3a1 1 0 1 0 0-2h-3V8Zm8-6a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
